const e = "_accent_ddpes_1", n = "_active_ddpes_92", a = "_danger_ddpes_123", c = "_warning_ddpes_246", t = {
  accent: e,
  active: n,
  danger: a,
  warning: c
};
export {
  e as accent,
  n as active,
  a as danger,
  t as default,
  c as warning
};
//# sourceMappingURL=ButtonAppearance.module.css.js.map
